import ar from './ar.json';
import en from './en.json';

/**
 * The Meetings module's catalogue, registered from `app.config.tsx` under the
 * `meetings` namespace — `shared/i18n` never imports a module (W2).
 *
 * `filter.cityOption` interpolates a count, so the Arabic carries all six CLDR
 * categories (`zero`/`one`/`two`/`few`/`many`/`other`) against English's two.
 * The parity spec compares key TREES, so a missing category is a failure rather
 * than a sentence that reads "2 أماكن".
 *
 * `nav.venues` is here **as well as** in `shared/i18n/common`: the sidebar reads
 * the shared one (it renders before any module catalogue is guaranteed loaded),
 * and this copy is what the page's own header uses.
 */
export const meetingsCatalogs = { ar, en };
